<div class="inline-flex h-[2.75rem] items-center">
  <ng-content></ng-content>
</div>
